import Vue from 'vue'
import axios from 'axios'
import router from './router'
import store from '@/state/store'

 
const axiosSwagger = axios.create({
    // baseURL: process.env.VUE_APP_SWAGGER_URL
    // baseURL: window.location.origin
    baseURL: Vue.prototype.$VUE_APP_SWAGGER_URL
});

// Add method to send data with DELETE requests
axiosSwagger.deleteWithBody = function(url, data, config = {}) {
    return this.request({
        ...config,
        method: 'delete',
        url,
        data
    });
};

 
 
axiosSwagger.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';

 


axiosSwagger.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${store.state.account.auth.user.token}`;
    // config.headers.Authorization = `'x-access-token': ${store.state.account.auth.user.token}`;
    return config;
});

axiosSwagger.interceptors.response.use( async response => {
    // Check if response indicates an error (either at root or in data object)
    const hasError = response?.data?.error === true || response?.data?.error === 'true';

    if(response?.status === 200 && hasError){

        if(!response?.config?.removeToast){
            const errorMsg = response?.data?.errorMessage || 'Something went wrong';
    
            Vue.$toast.error(errorMsg, {
                duration: 7000
            });
        }


        return Promise.reject(response);
    }

    // blob data with application/json type response
    if(response.config.responseType === 'blob'){
        let contentType = response.headers["content-type"];

        if (contentType.includes("json")) {
            const _blobData = JSON.parse(await response.data.text());

            if(_blobData?.error){
                Vue.$toast.error(_blobData.errorMessage, {
                    duration: 7000
                });
            }

            return Promise.reject(response);
        }
    }

    return response;
}, error => {
    if (error?.response?.status === 404) {
      router.push({name: '404'})
    }
    else if(error?.response?.status === 400){

        if(error?.response?.data?.errors ?? null){
            const errors = error.response.data.errors;
            const keys = Object.keys(errors);

            keys.forEach((key) => {

                errors[key].forEach((errorData) => {

                    let errorMsg = `${key}: ${errorData}`;

                    Vue.$toast.error(errorMsg, {
                        duration: 7000
                    });
                });
            });

        }
    }
    else if (error?.response?.status === 401) {
        // ℹ️ Logout user and redirect to login page
        // Remove "userData" from localStorage
        localStorage.removeItem('USER')
    
        // Remove "accessToken" from localStorage
        localStorage.removeItem('TOKEN')
    
        // If 401 response returned from api
        router.push('/login')
    }
    else{

        if(error?.response?.data?.includes("Invalid Login Attempt")){
            Vue.$toast.error("Invalid Login attempt.", {
                duration: 7000
            });
        }
        else if (error?.code && error?.message) { 
            Vue.$toast.error(error.message, {
                duration: 7000
            });
        }

    }

    return Promise.reject(error);
});



export {
    axiosSwagger
};